import Controller from "csi/action/Controller";
import localeProvider from "csi/page/localeProvider";
import { featureTogglesStore } from "csi/state/rootStore";
import xml from "csi/xml";
import Search from "csi/xml/Search";
import declare from "dojo/_base/declare";
import { CompositionStore } from "./CompositionStore";

const CompositionController = declare(Controller, {

	/** @property {boolean} fromTheme - true if from theme */
	fromTheme: false,

	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_cache, m_formData, fromTheme } = this;
		const search = new Search();
		search.getQuery()
			.Or()
			.Node(xml.PROP_TYPE, xml.OP_EQUALS, "Composition")
			.Node(xml.PROP_TYPE, xml.OP_EQUALS, "SustainabilityCompositionType")
			.And()
			.Node(xml.PROP_TYPE, xml.OP_EQUALS, "MaterialComposition")
			.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.getParentURL());

		const hasSustainability = !!featureTogglesStore.MATERIAL_COMPOSITION && !fromTheme;
		const request = search.getRequest();
		const response = await request.go();
		m_cache.cacheResponse(response);
		props.store = new CompositionStore(m_cache, m_formData, response.getNodesOfType("Composition"), localeProvider, props.onSave, hasSustainability, fromTheme);
	},
});

export = CompositionController;